import { isBefore, isEqual, sub } from "date-fns"
import { IsValidCheck } from "./types"

export const isOnCoverDateWithinLast13DaysError = `You can’t backdate cover past 13 days, please contact Customer Success`

export const isOnCoverDateWithinLast13Days: IsValidCheck = (entry, currentEntries, _, hasAdminAccess) => {
  if (hasAdminAccess || !entry.onCoverDate || !entry.uniqueRef) return undefined

  const onCoverDate = new Date(entry.onCoverDate as string)
  const currentEntry = currentEntries?.find((it) => it.uniqueRef === entry.uniqueRef)
  const past13Days = sub(new Date(), { days: 13 })
  if (!!currentEntry && isEqual(onCoverDate, new Date(currentEntry!.onCoverDate))) return undefined

  return !isBefore(onCoverDate, past13Days)
}
